import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleHomeClick = (e) => {
    e.preventDefault();
    navigate('/');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/80 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
      data-testid="main-navigation"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex justify-between items-center h-20">
          <Link to="/" onClick={handleHomeClick} className="font-playfair text-2xl font-bold text-primary" data-testid="logo-link">
            Villa Renaissance Garden
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="/" onClick={handleHomeClick} className="text-foreground hover:text-primary transition-colors" data-testid="nav-home">
              Home
            </a>
            <Link to="/garden" className="text-foreground hover:text-primary transition-colors" data-testid="nav-garden">
              The Garden
            </Link>
            <Link to="/gallery" className="text-foreground hover:text-primary transition-colors" data-testid="nav-gallery">
              Gallery
            </Link>
            <Link to="/#faq" className="text-foreground hover:text-primary transition-colors" data-testid="nav-faq">
              FAQ
            </Link>
            <Link to="/#reviews" className="text-foreground hover:text-primary transition-colors" data-testid="nav-reviews">
              Reviews
            </Link>
            <Link to="/contact" data-testid="nav-contact">
              <Button className="bg-primary hover:bg-primary/90 text-white rounded-sm transition-all hover:scale-105">
                Book Now
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-foreground"
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden py-4 space-y-4" data-testid="mobile-menu">
            <a
              href="/"
              onClick={(e) => {
                handleHomeClick(e);
                setIsOpen(false);
              }}
              className="block text-foreground hover:text-primary"
              data-testid="mobile-nav-home"
            >
              Home
            </a>
            <Link
              to="/garden"
              onClick={() => setIsOpen(false)}
              className="block text-foreground hover:text-primary"
              data-testid="mobile-nav-garden"
            >
              The Garden
            </Link>
            <Link
              to="/gallery"
              onClick={() => setIsOpen(false)}
              className="block text-foreground hover:text-primary"
              data-testid="mobile-nav-gallery"
            >
              Gallery
            </Link>
            <Link
              to="/#faq"
              onClick={() => setIsOpen(false)}
              className="block text-foreground hover:text-primary"
              data-testid="mobile-nav-faq"
            >
              FAQ
            </Link>
            <Link
              to="/#reviews"
              onClick={() => setIsOpen(false)}
              className="block text-foreground hover:text-primary"
              data-testid="mobile-nav-reviews"
            >
              Reviews
            </Link>
            <Link to="/contact" onClick={() => setIsOpen(false)} data-testid="mobile-nav-contact">
              <Button className="w-full bg-primary hover:bg-primary/90 text-white rounded-sm">
                Book Now
              </Button>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;